<template>
  <span class="em-body-3" :class="{'bold': bold, 'semi-bold': semiBold, 'regular': !bold && !semiBold}">
    <slot />
  </span>
</template>
<script setup>
defineProps({
  bold: {
    type: Boolean,
    default: false
  },
  semiBold: {
    type: Boolean,
    default: false
  }
})
</script>
<style lang="scss" scoped>
  .em-body-3{
    font-size: 13px !important;
    letter-spacing: 0px;
    line-height: 24px;
  }
  .em-body-3 :deep(.v-label) {
    font-size: 13px !important;
    letter-spacing: 0px;
    line-height: 24px;
  }
</style>
